import { render, staticRenderFns } from "./AddRemovePoints.template.vue?vue&type=template&id=1c144664&scoped=true&"
var script = {}
import style0 from "./AddRemovePoints.template.vue?vue&type=style&index=0&id=1c144664&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c144664",
  null
  
)

export default component.exports